module.exports = __webpack_public_path__ + "img/word.f4aeb555.jpg";